const { callAuthorizedGraphQLEndpoint } = require('../../../../Module/graphQL')

const getMissionsByCountry = queryVars => {
  const includeInventory = true

  const query = `query (
    $first:Int
    $skip:Int
    $countryId:ID!
    $cityId:ID
    $cityIds:[ID]
    $clientId:ID
    $clientIds:[ID]
    $locationId:ID
    $locationIds:[ID]
    $campaignId:ID
    $campaignIds:[ID]
    $startDate:String
    $startDates:[String]
    $endDate:String
    $endDates:[String]
    $statusAndAbove:MissionStatusEnum
    $statusAndAboves:[MissionStatusEnum]
    $statusAndBelow:MissionStatusEnum
    $statusAndBelows:[MissionStatusEnum]
    $timeOfDay:MissionTimeOfDayEnum
    $timeOfDays:[MissionTimeOfDayEnum]
    $filter:String
    $orderBy:MissionOrderByEnum
    $dayOfTheWeek:DayOfTheWeekEnum
    $dayOfTheWeeks:[DayOfTheWeekEnum]
    $reported:Boolean
    $reporteds:[Boolean]
    $includeMonths:[String]
    $includeYears:[String]
    $includeInventory:Boolean
    $noShow: Boolean
  ) {
    country(id: $countryId) {
      missions(
        countryId: $countryId
        cityId: $cityId
        cityIds: $cityIds
        first: $first
        skip: $skip
        clientId: $clientId
        clientIds: $clientIds
        locationId: $locationId
        locationIds: $locationIds
        campaignId: $campaignId
        campaignIds: $campaignIds
        startDate: $startDate
        startDates: $startDates
        endDate: $endDate
        endDates: $endDates
        statusAndAbove: $statusAndAbove
        statusAndAboves: $statusAndAboves
        statusAndBelow: $statusAndBelow
        statusAndBelows: $statusAndBelows
        timeOfDay: $timeOfDay
        timeOfDays: $timeOfDays
        filter: $filter
        orderBy: $orderBy
        dayOfTheWeek: $dayOfTheWeek
        dayOfTheWeeks: $dayOfTheWeeks
        reported: $reported
        reporteds: $reporteds
        includeMonths: $includeMonths
        includeYears: $includeYears
        includeInventory: $includeInventory
        noShow: $noShow
      ){
        edges {
          node {
            id
            cityName
            dateTime
            flyerCode
            isNotShown
            isStandby
            type
            teamLeaderGroupId
            flyerCodeV2 {
              tag
              code
            }
            status
            totalFlyersDistributed
            cityPlan {
              campaign {
                client {
                  name
                }
                metrics {
                  nodes {
                    id
                    label
                    name
                  }
                }
              }
              city {
                id
                afternoonCheckInTime
                lunchCheckInTime
              }
            }
            location {
              name
              id
            }
            user {
              id
              firstName
              lastName
            }
            metricResults {
              nodes {
                value
                metric {
                  id
                  label
                  name
                }
              }
            }
            amountScans
            canBeSpied
            spyInformation{
              spy{
                id
                firstName
                lastName
              }
              spyDetails{
                checkInTime
                checkoutTime
                reportReason
                }
              shift{
                id
              }
            }
            campaign{
            name
            }
            ratingInfo{
              rating
              conversionRateSubRating
              conversionRateMean
              scanRateSubRating
              scanRateMean
              checkoutFlyerRateSubRating
              checkoutFlyerRateMean
              comparisonScope
            }
          }

        }
        pageInfo {
          hasNextPage
        }
        totalCount
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    ...queryVars,
    includeInventory,
  })
}

const getMissionsByCity = queryVars => {
  const includeInventory = true

  const query = `query (
    $first:Int
    $skip:Int
    $cityId:ID!
    $clientIds:[ID]
    $locationIds:[ID]
    $campaignIds:[ID]
    $startDates:[String]
    $endDates:[String]
    $statusAndAboves: [MissionStatusEnum]
    $statusAndBelows: [MissionStatusEnum]
    $timeOfDays: [MissionTimeOfDayEnum]
    $filter:String
    $orderBy:MissionOrderByEnum
    $dayOfTheWeeks:[DayOfTheWeekEnum]
    $reporteds: [Boolean]
    $excludeArchivedCampaigns: Boolean
    $includeYears:[String]
    $includeInventory:Boolean
    $noShow: Boolean
  ) {
    city(id: $cityId){
      id
      name
      country { id }
      lunchCheckInTime
      afternoonCheckInTime
      missions(
        first: $first
        skip: $skip
        clientIds: $clientIds
        locationIds: $locationIds
        campaignIds: $campaignIds
        startDates: $startDates
        endDates: $endDates
        statusAndAboves: $statusAndAboves
        statusAndBelows: $statusAndBelows
        timeOfDays: $timeOfDays
        filter: $filter
        orderBy: $orderBy
        dayOfTheWeeks: $dayOfTheWeeks
        reporteds: $reporteds
        excludeArchivedCampaigns: $excludeArchivedCampaigns
        includeYears: $includeYears
        includeInventory: $includeInventory
        noShow: $noShow
      ){
        edges {
          node {
            id
            dateTime
            flyerCode
            isNotShown
            isStandby
            type
            teamLeaderGroupId
            flyerCodeV2 {
              tag
              code
            }
            status
            totalFlyersDistributed
            cancelled
            payoutRatio
            cityPlan {
              campaign {
                client {
                  name
                }
                metrics {
                  nodes {
                    id
                    label
                    name
                  }
                }
              }
              city {
                afternoonCheckInTime
                lunchCheckInTime
              }
            }
            location {
              name
              id
            }
            user {
              firstName
              lastName
              id
            }
            metricResults {
              nodes {
                value
                metric {
                  id
                  label
                  name
                }
              }
            }
            amountScans
            canBeSpied
            spyInformation{
              spy{
                id
                firstName
                lastName
              }
              spyDetails{
                checkInTime
                checkoutTime
                reportReason
                }
              shift{
                id
              }
            }
            campaign{
            name
            }
            ratingInfo{
              rating
              conversionRateSubRating
              conversionRateMean
              scanRateSubRating
              scanRateMean
              checkoutFlyerRateSubRating
              checkoutFlyerRateMean
              comparisonScope
            }
          }

        }
        pageInfo {
          hasNextPage
        }
        totalCount
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    ...queryVars,
    includeInventory,
  })
}

const updateMission = async input => {
  const query = `mutation updateMission($input: UpdateMissionInput!){
      updateMission(input: $input){
         mission{
        id
        canBeSpied
        }
      }
    }
  `

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const bookSpyMissions = async input => {
  const query = `mutation bookSpyMissions($input: BookSpyMissionsInput!){
    bookSpyMissions(input: $input){
      success
      shiftId
      warningText
    }
  }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const deleteSpyShift = async (input, options) => {
  const query = `mutation deleteSpyShift($input: DeleteSpyShiftInput!){
    deleteSpyShift(input: $input){
      success
    }
  }
  `

  return callAuthorizedGraphQLEndpoint(
    query,
    {
      input,
    },
    options,
  )
}

const addMissionOnExistingShift = async input => {
  const query = `mutation addMissionOnExistingShift($input: AddMissionToExistingSpyShiftInput!){
    addMissionOnExistingShift(input: $input){
      success
      shiftId
    }
  }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

export const getCitySettingsData = async cityId => {
  const query = `query ($cityId:ID!) {
      city(id: $cityId){
        id
        name
        teamLeaderEnabled
        isBaDocumentManagementEnabled
        isOnsiteTrainingEnabled
        country {
          code
        }
        spySettings {
          id
          cityId
          hourlyRate
          maxBudgetPerWeek
          travelAllowancePerMission
          travelAllowanceCap
          durationHandToHandMission
          durationLetterboxMission
          durationShift
          missionsPerShift
        }
      }
    }`
  return callAuthorizedGraphQLEndpoint(query, { cityId })
}

export {
  getMissionsByCountry,
  getMissionsByCity,
  updateMission,
  bookSpyMissions,
  deleteSpyShift,
  addMissionOnExistingShift,
}
